// extracted by mini-css-extract-plugin
export var banner = "_1n-0";
export var icon = "_1n-1";
export var message = "_1n-2";